<div *ngIf="bannerNode | async as item" class="main_inner-wrapper">
  <div *ngIf="item.uid=='SeqirusAccountDashboardBannerComponent'">
  <div >
<div class="col-xs-12" id="dashborad_topcontent" [style.backgroundImage]="item?.backgroundImage ? 'url(' + getImage(item.backgroundImage) + ')' : null" [ngClass]="currentSite === 'seqirusb2b-uk'?'uk_dashboard_TopBanner_BgImg':''">
  <div class="row dashboard-welcomesection">
    <ng-container *ngIf="currentSite === 'seqirusb2b-flu360';else ukbanner">
      <div class="col-xs-12 col-md-6 dashboradnewleft" id="dashborad_topcontentleftcontent">
        <h1 class="col-xs-12 modified-h1">{{'dashboard.welcometitle' | cxTranslate}}<span *ngIf="userData">
            {{userData?.firstName}}</span></h1>
        <!-- <div class="col-xs-12 margin-T20 currently-booking" [innerHTML]= " item.content"></div> -->
        <div class="col-xs-12 margin-T20 currently-booking">{{item.topContent}}</div>
        <div class="col-xs-12 padding-T5 currently-booking-seson">{{item.content}}</div>
        <div class="col-xs-12 padding-T5 currently-booking-seson">{{item.Content1}}</div>
        <!-- <div class="col-xs-12 padding-T5 currently-booking-seson">{{ item.h2content }}</div> -->
      </div>
    </ng-container>
    <ng-template #ukbanner>
      <div class="col-xs-12 col-md-6 dashboradnewleft" id="dashborad_topcontentleftcontentuk">
        <h1 class="col-xs-12 modified-h1">{{'dashboard.welcometitle' | cxTranslate}}<span *ngIf="userData">
            {{userData?.firstName}}</span></h1>

        <!-- <div class="col-xs-12 margin-T20 currently-booking"></div>
        
        <div class="col-xs-12 padding-T5 currently-booking-seson"></div> -->
        <div class="meeting_Section">
          <p class="book_Meeting">{{item.topContent}}</p>
          <button class="check_Availability_Btn" [disabled]="isAsAgent" [class.disabled-btn]="isAsAgent" (click)="openCalendly()">{{'orders.check_Availability_Text' |
            cxTranslate}}<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M2 12C2 8.229 2 6.343 3.172 5.172C4.344 4.001 6.229 4 10 4H14C17.771 4 19.657 4 20.828 5.172C21.999 6.344 22 8.229 22 12V14C22 17.771 22 19.657 20.828 20.828C19.656 21.999 17.771 22 14 22H10C6.229 22 4.343 22 3.172 20.828C2.001 19.656 2 17.771 2 14V12Z"
                stroke="white" stroke-width="1.5" />
              <path d="M7 4V2.5M17 4V2.5M2.5 9H21.5" stroke="white" stroke-width="1.5" stroke-linecap="round" />
              <path
                d="M18 17C18 17.2652 17.8946 17.5196 17.7071 17.7071C17.5196 17.8946 17.2652 18 17 18C16.7348 18 16.4804 17.8946 16.2929 17.7071C16.1054 17.5196 16 17.2652 16 17C16 16.7348 16.1054 16.4804 16.2929 16.2929C16.4804 16.1054 16.7348 16 17 16C17.2652 16 17.5196 16.1054 17.7071 16.2929C17.8946 16.4804 18 16.7348 18 17ZM18 13C18 13.2652 17.8946 13.5196 17.7071 13.7071C17.5196 13.8946 17.2652 14 17 14C16.7348 14 16.4804 13.8946 16.2929 13.7071C16.1054 13.5196 16 13.2652 16 13C16 12.7348 16.1054 12.4804 16.2929 12.2929C16.4804 12.1054 16.7348 12 17 12C17.2652 12 17.5196 12.1054 17.7071 12.2929C17.8946 12.4804 18 12.7348 18 13ZM13 17C13 17.2652 12.8946 17.5196 12.7071 17.7071C12.5196 17.8946 12.2652 18 12 18C11.7348 18 11.4804 17.8946 11.2929 17.7071C11.1054 17.5196 11 17.2652 11 17C11 16.7348 11.1054 16.4804 11.2929 16.2929C11.4804 16.1054 11.7348 16 12 16C12.2652 16 12.5196 16.1054 12.7071 16.2929C12.8946 16.4804 13 16.7348 13 17ZM13 13C13 13.2652 12.8946 13.5196 12.7071 13.7071C12.5196 13.8946 12.2652 14 12 14C11.7348 14 11.4804 13.8946 11.2929 13.7071C11.1054 13.5196 11 13.2652 11 13C11 12.7348 11.1054 12.4804 11.2929 12.2929C11.4804 12.1054 11.7348 12 12 12C12.2652 12 12.5196 12.1054 12.7071 12.2929C12.8946 12.4804 13 12.7348 13 13ZM8 17C8 17.2652 7.89464 17.5196 7.70711 17.7071C7.51957 17.8946 7.26522 18 7 18C6.73478 18 6.48043 17.8946 6.29289 17.7071C6.10536 17.5196 6 17.2652 6 17C6 16.7348 6.10536 16.4804 6.29289 16.2929C6.48043 16.1054 6.73478 16 7 16C7.26522 16 7.51957 16.1054 7.70711 16.2929C7.89464 16.4804 8 16.7348 8 17ZM8 13C8 13.2652 7.89464 13.5196 7.70711 13.7071C7.51957 13.8946 7.26522 14 7 14C6.73478 14 6.48043 13.8946 6.29289 13.7071C6.10536 13.5196 6 13.2652 6 13C6 12.7348 6.10536 12.4804 6.29289 12.2929C6.48043 12.1054 6.73478 12 7 12C7.26522 12 7.51957 12.1054 7.70711 12.2929C7.89464 12.4804 8 12.7348 8 13Z"
                fill="white" />
            </svg>
          </button>
        </div>
      </div>
    </ng-template>
    <div [style.backgroundImage]="item?.backgroundImage ? 'url(' + getImage(item.backgroundImage) + ')' : null" *ngIf="currentSite === 'seqirusb2b-uk'" class="logo_Container">
      <div class="images_Column">
        <img src="assets/images/aujem.png" class="aujem_Img">
        <img src="assets/images/ativ.png" class="ativ_Img">
        <img src="assets/images/tivc.png" class="tivc_Img">
      </div>
    </div>
<!--UK Book a meeting section-->
  <!-- <div class="middle_section" *ngIf="currentSite === 'seqirusb2b-uk' && calendlyData?.isCalendlyEnabled && calendlyData?.calendlyId">
    <div class="col-xs-12"  id="dashborad_MiddleContentUk">
      <p class="book_Meeting">{{item.topContent}}</p>
      <button class="check_Availability_Btn" (click)="openCalendly()" data-bs-target="#calendly_PopUp" data-bs-toggle="modal">{{'orders.check_Availability_Text' | cxTranslate}}</button>
       <button class="check_Availability_Btn" (click)="openCalendly()">{{'orders.check_Availability_Text' | cxTranslate}}</button>
    </div>
  </div> -->
  <!--calnedly pop-up-->
  <!-- <section *ngIf="currentSite === 'seqirusb2b-uk'">
      <div id="calendly_PopUp" class="modal fade in" data-bs-backdrop="static" role="dialog">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              <div class="close_PopUp">
                <span data-bs-dismiss="modal" class="close_Btn"><i class="fa-solid fa-x"></i></span>
              </div>
              <div id="calendly-embed" class="calendly-inline-widget"></div>
              <div class="clearboth"></div>
            </div>
          </div>
        </div>
      </div>
  </section> -->
<!--UK photo section-->
  <!-- <div id="dashborad_RightContentUk" class="photo_Section" *ngIf="currentSite === 'seqirusb2b-uk'">
      <img [src]="getImage(item?.image)" class="rightSection_Img"> 
  </div> -->

  <!-- <div class="col-xs-12 col-md-6 dashboardadjustableright" id="dashborad_topcontentrightcontent">
      <div *ngIf="currentSite !== 'seqirusb2b-uk'" class="row dashboard-ordervalues">
          <div class="col-md-5 dashborad_openorders" *ngIf="orderData">
            <div class="col-xs-12 dashborad_opennumbers" >{{orderData}}</div>
            <div class="col-xs-12 pl-0">Open Orders</div>              
          </div>
    
        <ng-template #ukbanner>
          <div class="col-12 col-md-6 dashboradnewleft" id="dashborad_topcontentleftcontentuk">
            <h1 class="col-12 modified-h1">
              Welcome back,<span *ngIf="userData"> {{userData?.firstName}}</span>
            </h1>
            <div class="col-12 margin-T20 currently-booking"></div>
            <div class="col-12 padding-T5 currently-booking-seson"></div>
          </div>
        </ng-template>
    
      </div>
  </div> -->
  <div class="col-12 col-md-6 dashboardadjustableright" id="dashborad_topcontentrightcontent">
    <div *ngIf="currentSite !== 'seqirusb2b-uk'" class="row dashboard-ordervalues">
      <div class="col-md-5 dashborad_openorders" *ngIf="orderData">
        <div class="col-12 dashborad_opennumbers">{{orderData}}</div>
        <div class="col-12 ps-0">{{'orders.title' | cxTranslate}}</div>
      </div>
      <div class="col-1 dashborad_sperator"></div>
      <div class="col-md-5 dashborad_openInvoices" *ngIf="invoiceNode">
        <div class="col-12 dashborad_opennumbers dashboard_openInvoiceNumbers">{{invoiceNode}}</div>
        <div class="col-12 p-0">{{'invoice.title' | cxTranslate}}</div>
      </div>
    </div>
  </div>
</div>
</div>

<!--Calendly External link Popup-->
<div class="commonleaving_abandonedPop modal" role="dialog" data-bs-backdrop="static"
  [ngClass]="{'show': isCalendlyModalOpen}" id="dashboard_commonleaving_abandonedPop"
  [style.display]="isCalendlyModalOpen ? 'block' : 'none'">
  <div class="knowledgeHub_abandonedPopContent">
    <div class="knowledgeHub_abandonedPopHeader">
      <div class="knowledgeHub_abandonedPopTitle">{{popupdata?.headline}}</div>
      <div class="knowledgeHub_abandonedPopClose" (click)="closeCalendlyModal()">X</div>
      <div class="clearboth"></div>
    </div>
    <div class="knowledgeHub_abandonedPopText">
      <p [innerHTML]="popupdata?.message1" class="popup_Text1"></p>
      <p [innerHTML]="popupdata?.message2" class="popup_Text1"></p>
    </div>
    <div class="knowledgeHub_abandonedPopBtns">
      <button class="knowledgeHub_abandonedPopBtn commonleave_popContBtn"
        (click)="openCalendlyUrl()">{{popupdata?.label1}}</button>
      <button class="knowledgeHub_abandonedPopBtn knowledgeHub_popCanceltBtn"
        (click)="closeCalendlyModal()">{{popupdata?.label2}}</button>
    </div>
    <div class="knowledgedocnumberUk">{{popupdata?.jobBagCode}}</div>
  </div>
</div>